export default __webpack_public_path__ + "static/media/c-web-logo-white.3c957c4c.png";